import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Skeleton from '../../../common/skeleton';

const RightSection = () => {
  return (
    <>
      <Col sm={9}>
        <div className="details-section secondary-background">
          <div className="tabs-section">
            <div className="provider-information find-provider-bottom-border">
              <Row className="primary-background row m-0 p-0 pt-4 pb-4">
                <Col sm={4} className="phone-info">
                  <Skeleton
                    height={12}
                    count={3}
                    containerClassName={'details-page-phone-info'}
                  />
                </Col>
                <Col sm={4} className="address-info">
                  <Skeleton
                    height={12}
                    count={3}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
                <Col sm={4} className="text-right">
                  <Skeleton
                    height={12}
                    count={2}
                    width={150}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
              </Row>
              <Row className="m-0 p-0 pt-4 pb-4">
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
              </Row>
            </div>
            <div className="provider-professional-information find-provider-bottom-border">
              <Row className="m-0 p-0 pt-4">
                <Col sm={4}>
                  <Skeleton
                    height={24}
                    count={1}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
              </Row>
              <Row className="m-0 p-0 pt-4 pb-3">
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
              </Row>
              <Row className="m-0 p-0 pb-3">
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
              </Row>
            </div>
            <div className="provider-facilities-information">
              <Row className="m-0 p-0 pt-4">
                <Col sm={4}>
                  <Skeleton
                    height={24}
                    count={1}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
              </Row>
              <Row className="m-0 p-0 pt-4 pb-3">
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
              </Row>
              <Row className="m-0 p-0 pb-4">
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
                <Col sm={4}>
                  <Skeleton
                    height={12}
                    count={2}
                    containerClassName={'details-page-provider-address'}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Col>
    </>
  );
};

export default RightSection;
